<adspt-icon [ngStyle]="{ 'font-size.px': size() }" class="adspt-icon {{ color() }}-text" [name]="icon()" />
